import type { ReactElement } from "react";
import { Text } from "@primitives/index";

export function ValidationNote({ children }: { readonly children: string }): ReactElement {
    return (
        <Text role="caption" tone="danger">
            {children}
        </Text>
    );
}
